import React from 'react';

export const ProgramsDialog = () => {
  return <div></div>;
};
